let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

/* ===== custom: seamless forward loop for the Dawn main slideshow (non-destructive add-on) ===== */
(function () {
  function enhance(component) {
    if (component.dataset.seamlessLoop === 'true') return;
    if (component.querySelector('.announcement-bar-slider')) return; // お知らせバーは除外
    if (!component.sliderControlWrapper) return;
    if (!component.slider || component.slider.getAttribute('data-autoplay') !== 'true') return;
    if (!component.sliderItemsToShow || component.sliderItemsToShow.length < 2) return;

    component.dataset.seamlessLoop = 'true';
    var slider = component.slider;

    var clone = component.sliderItemsToShow[0].cloneNode(true);
    clone.removeAttribute('id');
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-slide-clone', 'true');
    clone.querySelectorAll('[id]').forEach(function (el) {
      el.removeAttribute('id');
    });
    clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(function (el) {
      el.setAttribute('tabindex', '-1');
    });
    slider.appendChild(clone);

    var placeholder = document.createElement('span');
    placeholder.className = 'slider-counter__link';
    placeholder.setAttribute('aria-hidden', 'true');
    placeholder.setAttribute('tabindex', '-1');
    placeholder.style.display = 'none';
    component.sliderControlWrapper.appendChild(placeholder);

    component.autoRotateSlides = function () {
      var realCount = this.sliderItemsToShow.length;
      this.setSlidePosition(this.slider.scrollLeft + this.sliderItemOffset);

      if (this.currentPage === realCount) {
        var buttons = this.querySelectorAll('.slider-counter__link');
        if (buttons.length) {
          buttons.forEach(function (b) {
            b.classList.remove('slider-counter__link--active');
            b.removeAttribute('aria-current');
          });
          buttons[0].classList.add('slider-counter__link--active');
          buttons[0].setAttribute('aria-current', 'true');
        }
        var self = this;
        if (this._loopReset) clearTimeout(this._loopReset);
        this._loopReset = setTimeout(function () {
          var prev = self.slider.style.scrollBehavior;
          self.slider.style.scrollBehavior = 'auto';
          self.slider.scrollTo({ left: 0 });
          self.slider.getBoundingClientRect();
          self.slider.style.scrollBehavior = prev;
          self.currentPage = 1;
        }, 600);
      }
    };

    if (typeof component.pause === 'function' && typeof component.play === 'function') {
      component.pause();
      component.play();
    }
  }

  function init() {
    if (!window.customElements || !customElements.get('slideshow-component')) {
      window.setTimeout(init, 60);
      return;
    }
    document.querySelectorAll('slideshow-component').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();